import Vue from 'vue'

export default {

  setCriterionValue(state, {name, value}){
      const currentCriteria = state.criteria.find((criteria) => criteria.name === name);

      if(currentCriteria && currentCriteria.required){
          currentCriteria.unvalid = !value;
      }

      Vue.set(state.selectedCriteria, name, value);
  },

    setMode(state, {value}){
      Vue.set(state, 'mode', value);
    },

    setActiveStepByIndex(state, next){

        let current = state.steps.findIndex((step) => step.active);
        if(current !== -1){
            //return if not valid
            state.steps[current].active = false;
        }
        state.steps[next].active = true;

    },

    setStepValidClass(state, validClass){
        let current = state.steps.findIndex((step) => step.active);
        if(current !== -1){
            Vue.set(state.steps[current], 'validClass', validClass)
        }

    },
  setProducts(state, products){
    state.products = products;
  },

   setSteps(state, steps){
    state.steps = steps;
   },

    setCriteria( state, criteria){
      state.criteria = criteria;
    },


    addProductInCartByType(state, {id, type}){
        // state.products.filter((product)=> product.type === type).forEach((product) => product.inCart = product.id === id);
        state.products.filter((product)=> product.type === type).forEach((product) => {

            if(product.id === id){
                product.inCart = !product.inCart
            }else{
                product.inCart = false;
            }

        });

    },


};

